
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { AssetsUserDetailsEntityDecorator } from '../../userdetails/model/assets-user-details.decorator';
import { AssetsUserDetails } from '../../userdetails/model/assets-user-details.model';
import { TRANSFER_ASSET_APPROVER_METADATA } from './transfer-asset-approver.metadata';
import { TransferAssetApprover } from './transfer-asset-approver.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class TransferAssetApproverEntityDecoratorBase extends GenericEntityDecorator<TransferAssetApprover, string> {
  constructor() {
    super(TRANSFER_ASSET_APPROVER_METADATA, {
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      },
      get user(): EntityDecorator<AssetsUserDetails, string> {
        return new AssetsUserDetailsEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): string {
    if (params == null || params.approverId == null) {
      return null;
    }
    return params.approverId;
  }
  toKeyUrlPathSegments(key: string): string {
    if (key == null) {
      return null;
    }
    return key;
  }
  toKeyRouteSegments(item: TransferAssetApprover): any[] {
    const key: string = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




